import { EVENT } from '../constants'
import { GA4Event, GA4GeneralProps } from '../GA4Event'

export interface GA4ContentGenerateEventProps extends GA4GeneralProps {
  featureClass: string
  featureName?: string | null
  generativeMethod?: string | null
  threadId?: string | null
}

export class GA4ContentGenerateEvent extends GA4Event {
  ga4_feature_class: GA4ContentGenerateEventProps['featureClass']
  ga4_feature_name: GA4ContentGenerateEventProps['featureName']
  ga4_generative_method: GA4ContentGenerateEventProps['generativeMethod']
  ga4_thread_id: GA4ContentGenerateEventProps['threadId']

  constructor({
    featureClass,
    featureName = null,
    generativeMethod = null,
    threadId = null,
    ...generalProps
  }: GA4ContentGenerateEventProps) {
    super({ event: EVENT.CONTENT_GENERATE, ...generalProps })

    this.ga4_feature_class = featureClass
    this.ga4_feature_name = featureName
    this.ga4_generative_method = generativeMethod
    this.ga4_thread_id = threadId
  }
}
